<div container classes="container--1096">
  <div class="cards d-flex flex-column">
    @for (card of cards; track $index) {
      <div
        class="card card--{{
          card.color
        }} d-flex flex-column flex-lg-row align-items-lg-center"
      >
        <h3 class="text-lg-center mb-lg-0" [innerHTML]="card.title"></h3>
        <hr class="d-none d-lg-block" />
        <div class="card__text">
          <p class="mb-0" [innerHTML]="card.text"></p>
          @if (card.list) {
            <ul class="mt-2 mb-0">
              @for (bullet of card.list; track $index) {
                <li [innerHTML]="bullet"></li>
              }
            </ul>
          }
        </div>
      </div>
    }
    <div
      class="align-items-lg-center card card--aqua d-flex flex-column flex-lg-row"
    >
      <h3 class="text-lg-center mb-lg-0">Know the options</h3>
      <hr class="d-none d-lg-block" />
      <div class="card__text">
        <p class="mb-0">
          Advancements in
          <a class="fw-bold" target="_blank" rel="noopener" (click)="onClick()"
            >treatment</a
          >
          and management of autoimmune type 1 diabetes may offer ways to help.
          Talk to your or your loved one’s doctor about what could come next.
          You or your loved one may be able to participate in a clinical trial
          or explore available treatment options.
        </p>
      </div>
    </div>
  </div>
</div>
